import { createContext } from 'react';
export var topModelContext = createContext({});
